/* eslint-disable no-underscore-dangle */
import axios from '@fs/zion-axios'
import { baseUrl } from '@fs/zion-config'

export default () => {}

const BASE_PATH = '/service/dmc/tools'
const CHUNK_SIZE = 5.5 * 1024 * 1024 // has to be at least 5MB

export function getDatsLinks() {
  return axios.get(`${BASE_PATH}/`).then((response) => {
    // eslint-disable-next-line no-underscore-dangle
    return response.data._links
  })
}

export function getTools() {
  return axios.get(`${BASE_PATH}/discovery/tools`).then((response) => {
    return response.data
  })
}

export function uploadFileToS3Directly(s3Url, fileData) {
  // eslint-disable-next-line no-console

  s3Url = s3Url.replace('https://ps-services-us-east-1-074150922133.s3.amazonaws.com', `${BASE_PATH}/s3UploadFile/inte`)
  s3Url = s3Url.replace('https://ps-services-us-east-1-643055571372.s3.amazonaws.com', `${BASE_PATH}/s3UploadFile/beta`)
  s3Url = s3Url.replace('https://ps-services-us-east-1-914248642252.s3.amazonaws.com', `${BASE_PATH}/s3UploadFile/prod`)
  return axios
    .put(s3Url, fileData)
    .then((response) => {
      // eslint-disable-next-line no-console
      return response.data
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.err(`uploadFileToS3Directly:err: ${JSON.stringify(err, null, 2)}`)
    })
}

function startMultipartInputUpload(job) {
  const url = `${BASE_PATH}/startMultipartInputUpload?url=${job._links.startMultipartInputUpload.href}`
  return axios
    .post(url)
    .then((response) => {
      return response.data
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.err(`startMultipartInputUpload:err: ${JSON.stringify(err, null, 2)}`)
    })
}

export function uploadMultiPartInput(inputFile, response, createJobActions) {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-console

    const reader = new FileReader()
    reader.onload = async (event) => {
      const fileResult = event.target.result
      const fileContents = new Uint8Array(fileResult)

      if (fileContents.length > 0) {
        startMultipartInputUpload(response)
          .then((startResponse) => {
            let serialChain = Promise.resolve()
            const results = []
            let job = startResponse
            for (let index = 0; index < fileContents.length; index += CHUNK_SIZE) {
              const end = index + CHUNK_SIZE > fileContents.length ? fileContents.length : index + CHUNK_SIZE
              const chunk = fileContents.slice(index, end)

              const progress = end / fileContents.length
              const isLast = end >= fileContents.length
              serialChain = serialChain
                // eslint-disable-next-line no-loop-func
                .then(() => uploadMultipartInputChunk(job, chunk, isLast))
                // eslint-disable-next-line no-loop-func
                .then(async (multipartUploadResult) => {
                  if (
                    multipartUploadResult &&
                    multipartUploadResult.status >= 200 &&
                    multipartUploadResult.status < 300
                  ) {
                    job = multipartUploadResult.data
                    results.push(multipartUploadResult.data)
                    createJobActions.setUploadProgress(progress)
                  } else {
                    reject(multipartUploadResult)
                  }
                  if (isLast) {
                    resolve(results)
                  }
                })
            }
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(`uploadMultiPartInput:err:${err}`)
            reject(err)
          })
      }
    }
    reader.onerror = (err) => {
      // eslint-disable-next-line no-console
      reject(err)
    }
    reader.readAsArrayBuffer(inputFile)
  })
}
function uploadMultipartInputChunk(job, chunk, isLast) {
  let url = `${BASE_PATH}/uploadMultipartInputChunk?url=${job._links.next.href}`
  url += `&isLastPart=${isLast ? 'true' : 'false'}`

  const options = {
    headers: { 'Content-Type': 'binary/octet-stream' },
  }

  return axios
    .post(url, chunk, options)
    .then((response) => {
      return response
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.err(`uploadMultipartInputChunk:err: ${JSON.stringify(err, null, 2)}`)
      return null
    })
}

export function notifyDATSThatFileIsReady(jobId) {
  const url = `${BASE_PATH}/jobs/${jobId}`
  const body = {
    statusChangeRequest: 'InputFileReady',
  }
  return axios.put(url, body).then((response) => {
    return response.data
  })
}

export function createJob(assignment, toolHref, inputText, itemsPerRequest, requestsPerSecond, parameters) {
  const body = {
    assignment,
    _links: {
      tool: {
        href: toolHref,
      },
    },
    itemsPerRequest,
    requestsPerSecond,
    _attributes: {
      fileContent: inputText,
    },
  }
  parameters.forEach((item) => {
    if (item.key && item.key.length > 0 && item.value && item.value.length > 0) {
      /* eslint no-underscore-dangle: ["error", { "allow": ["_attributes"] }] */
      body._attributes[`PARAMETER_${item.key}`] = item.value
    }
  })
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }
  return axios.post(`${BASE_PATH}/jobs`, body, config).then((response) => {
    return response.data
  })
}

export function getPagedJobResults(jobId, start, count, includeSuccessful, includeFailures) {
  const params = {}
  params.start = start || 0
  params.count = count || 30
  if (!includeSuccessful) params.excludeSuccess = !includeSuccessful
  if (!includeFailures) params.excludeFailure = !includeFailures
  const queryString = new URLSearchParams(params).toString()
  const url = `${BASE_PATH}/jobs/${jobId}/results${queryString ? `?${queryString}` : ''}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getPagedJobInputs(jobId, start, count) {
  const params = {}
  params.start = start || 0
  params.count = count || 30
  const queryString = new URLSearchParams(params).toString()
  const url = `${BASE_PATH}/jobs/${jobId}/input${queryString ? `?${queryString}` : ''}`
  return axios.get(url).then((response) => {
    return response.data.split(/\r?\n/)
  })
}

export function getJobs(start, count, jobStatusList, cisId, toolGroup, toolName, includeObjectDatabase) {
  const params = {}
  params.start = start || 0
  params.count = count || 30
  if (jobStatusList && jobStatusList.length > 0) params.jobStatus = jobStatusList
  if (cisId) params.userId = cisId
  if (toolName) params.toolName = toolName
  if (toolGroup) params.toolGroup = toolGroup
  if (includeObjectDatabase) params.includeObjectDatabase = includeObjectDatabase
  const queryString = new URLSearchParams(params).toString()
  const url = `${BASE_PATH}/jobs${queryString ? `?${queryString}` : ''}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getJobResultsQueries(jobId) {
  const url = `${BASE_PATH}/jobs/${jobId}/result-queries`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function getJob(jobId) {
  const url = `${BASE_PATH}/jobs/${jobId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export function passThrough(path, httpMethod, body, headers) {
  return axios({
    url: `${BASE_PATH}${path}`,
    method: httpMethod,
    data: body,
    headers,
  }).then((response) => {
    return response.data
  })
}

export function postResultQuery(jobId, resultQuery) {
  const url = `${BASE_PATH}/jobs/${jobId}/result-queries`
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }
  return axios.post(url, resultQuery, config).then((response) => {
    return response.data
  })
}

export function processIds(conversionType, idList = []) {
  const url = `${BASE_PATH}/localTool/idConverter?conversionType=${conversionType}`
  return axios.put(url, idList).then((response) => {
    return response.data
  })
}

export function getBaseUrl() {
  const { REACT_APP_DMC_SERVER } = process.env
  if (REACT_APP_DMC_SERVER === 'localhost') {
    return 'http://localhost:8080/tools'
  }
  return `${baseUrl}${BASE_PATH}`
}

/**
 * Fetches the list of DATS users.
 * @returns {Promise<Array<{userId: string, fullName: string}>>} A promise that resolves to an array of user objects
 */
export function getUsers() {
  return axios.get(`${BASE_PATH}/users`).then((response) => {
    return response.data
  })
}
